*,
::before,
::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  align-items: center;
  align-self: stretch;
  outline: unset;
  touch-action: manipulation;
  user-select: none;
}

:host(.ch-checkbox--actionable) :is(.input, .label) {
  cursor: pointer;
}

.container {
  position: relative;
  width: min(1em, 20px);
  height: min(1em, 20px);
  border: 1px solid var(--option-border-color, currentColor);
  border-radius: 18.75%;
}
.container--checked {
  background-color: var(--option-checked-color, #ffffff00);
}
.container:focus-within {
  box-shadow: 0 0 1px 1px color-mix(in srgb, currentColor 25%, transparent);
}

.input {
  display: flex;
  width: 100%;
  height: 100%;
  opacity: 0;
  margin: 0;
  padding: 0;
}

.option {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: 50%;
  background-color: currentColor;
  opacity: 0;
  pointer-events: none;
}
.option--checked {
  opacity: 1;
  -webkit-mask: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8' %3E%3Cpath fill='currentColor' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z' /%3E%3C/svg%3E");
}
.option--indeterminate {
  opacity: 1;
}

.label {
  margin-inline-start: min(0.35em, 7px);
}